document.querySelectorAll(".js-parallax-image").forEach(a=>{new simpleParallax(a,{scale:1.2,delay:.6,transition:"cubic-bezier(0,0,0,1)"})});
//# sourceMappingURL=textboximageteaser.js.map
